<app-header></app-header>

<div class="create-profile-container">
  <!-- Tabs Navigation -->
  @if (isMobileView) {
  <div class="tabs-navigation">
    <button class="tab-btn" [class.active]="viewMode === 'profiles' && activeTab === 'create'" (click)="openProfilesView('create')">
      <i class="fas fa-user-plus mr-2"></i>
      Create User Profile
    </button>
    <button class="tab-btn" [class.active]="viewMode === 'profiles' && activeTab === 'view'" (click)="openProfilesView('view')">
      <i class="fas fa-users mr-2"></i>
      View Users
    </button>
    <button class="tab-btn" [class.active]="viewMode === 'access'" (click)="openAccessView()">
      <i class="fas fa-user-shield mr-2"></i>
      Manage Access
    </button>
    @if (isAdmin) {
    <button class="tab-btn" [class.active]="viewMode === 'flows'" (click)="openFlowsView()">
      <i class="fas fa-sitemap mr-2"></i>
      Approval flows
    </button>
    <button class="tab-btn" [class.active]="viewMode === 'history'" (click)="openHistoryView()">
      <i class="fas fa-history mr-2"></i>
      Access history
    </button>
    <button class="tab-btn" [class.active]="viewMode === 'acting'" (click)="openActingView()">
      <i class="fas fa-user-tag mr-2"></i>
      Acting for
    </button>
    }
  </div>
  } @else {
  <div class="view-switch">
    <button type="button" class="tab-btn" [class.active]="viewMode === 'profiles'" (click)="openProfilesView(activeTab)">
      <i class="fas fa-id-card mr-2"></i>
      Profiles
    </button>
    <button type="button" class="tab-btn" [class.active]="viewMode === 'access'" (click)="openAccessView()">
      <i class="fas fa-user-shield mr-2"></i>
      Manage Access
    </button>
    @if (isAdmin) {
    <button type="button" class="tab-btn" [class.active]="viewMode === 'flows'" (click)="openFlowsView()">
      <i class="fas fa-sitemap mr-2"></i>
      Approval flows
    </button>
    <button type="button" class="tab-btn" [class.active]="viewMode === 'history'" (click)="openHistoryView()">
      <i class="fas fa-history mr-2"></i>
      Access history
    </button>
    <button type="button" class="tab-btn" [class.active]="viewMode === 'acting'" (click)="openActingView()">
      <i class="fas fa-user-tag mr-2"></i>
      Acting for
    </button>
    }
  </div>
  }

  @if (viewMode === 'acting' && isAdmin) {
  <div class="flows-wrap">
    <div class="flows-head">
      <div>
        <h3>Acting for</h3>
        <p>Give a person specific powers without making them an Admin: give tasks in your name, approve in Finance on your behalf, assign leads. Everything done under a power is recorded as "them, on behalf of you". Powers can end on a date and can be taken back any time.</p>
      </div>
    </div>
    <div class="act-grid">
      <div class="act-form">
        <h4>Give powers</h4>
        <label class="act-label">Person</label>
        <div class="act-user">
          <input type="text" class="hist-input" placeholder="Search a person by name or department" [(ngModel)]="actUserSearch" (ngModelChange)="actPicked = null" />
          @if (actPicked) {
            <button type="button" class="act-clear" (click)="clearActUser()" title="Clear"><i class="fas fa-times"></i></button>
          }
          @if (actUserSearch.trim() && !actPicked && !actFilteredUsers.length) {
          <div class="act-user-list act-user-empty">No one matches “{{ actUserSearch }}”. Try a first name or a department.</div>
          }
          @if (actFilteredUsers.length) {
          <div class="act-user-list">
            @for (u of actFilteredUsers; track u._id) {
            <button type="button" (click)="pickActUser(u)">
              <img [src]="u.profileImg || 'assets/default-profile.jpeg'" alt="" />
              <span class="n">{{ actName(u) }}</span>
              <small>{{ u.department }}</small>
            </button>
            }
          </div>
          }
        </div>
        <label class="act-label">Powers</label>
        @for (m of actModules; track m.module) {
        <div class="act-module">
          <span class="act-module-name">{{ m.module }}</span>
          @for (p of m.powers; track p.key) {
          <label class="act-power" [class.on]="actForm.powers.includes(p.key)">
            <input type="checkbox" [checked]="actForm.powers.includes(p.key)" (change)="togglePower(p.key)" />
            <span><b>{{ p.label }}</b><small>{{ p.description }}</small></span>
          </label>
          }
        </div>
        }
        <div class="act-two">
          <div>
            <label class="act-label">Acting for</label>
            <select class="hist-input" [(ngModel)]="actForm.actsForUserId">
              <option value="">Me</option>
              @for (a of actAdmins; track a._id) {
              <option [value]="a._id">{{ actName(a) }}</option>
              }
            </select>
          </div>
          <div>
            <label class="act-label">Until (optional)</label>
            <input type="date" class="hist-input" [(ngModel)]="actForm.endsOn" />
          </div>
        </div>
        <label class="act-label">Note (optional)</label>
        <input type="text" class="hist-input" placeholder="why, in a few words" [(ngModel)]="actForm.note" maxlength="300" />
        @if (actError) { <div class="act-error">{{ actError }}</div> }
        <button type="button" class="flows-btn primary act-save" [disabled]="!actCanSave" (click)="saveGrant()">{{ actSaving ? 'Saving…' : 'Give powers' }}</button>
      </div>

      <div class="act-list">
        @if (actLoading && !actRows.length) {
          <div class="flows-empty">Loading…</div>
        } @else if (!actRows.length) {
          <div class="flows-empty">Nobody holds delegated powers yet.</div>
        } @else {
          @for (r of actRows; track r.id) {
          <div class="flow-card act-card" [class.off]="!r.active || r.expired">
            <div class="act-who">
              <img [src]="r.delegate.profileImg || 'assets/default-profile.jpeg'" alt="" />
              <div>
                <div><b>{{ r.delegate.name }}</b> <span class="hist-dept">{{ r.delegate.department }}</span>
                  @if (!r.active) { <span class="act-badge off">taken back {{ actWhen(r.revokedAt) }}</span> } @else if (r.expired) { <span class="act-badge off">ended {{ r.endsOn }}</span> } @else if (r.endsOn) { <span class="act-badge">until {{ r.endsOn }}</span> }
                </div>
                <div class="act-meta">acting for <b>{{ r.actsFor.name }}</b> · given by {{ r.grantedBy.name }} on {{ actWhen(r.createdAt) }}{{ r.note ? ' · ' + r.note : '' }}</div>
                <div class="hist-chips act-chips">
                  @for (p of r.powers; track p) { <span class="hist-chip fin">{{ powerLabel(p) }}</span> }
                </div>
              </div>
            </div>
            @if (r.active && !r.expired) {
              <button type="button" class="flows-btn danger" (click)="revokeGrant(r)">Take back</button>
            }
          </div>
          }
        }
      </div>
    </div>
  </div>
  }

  <!-- ── Access history (Admin) ────────────────────────────────────────── -->
  @if (viewMode === 'history' && isAdmin) {
  <div class="flows-wrap">
    <div class="flows-head">
      <div>
        <h3>Access history</h3>
        <p>Every access change the server applied: who changed whose modules, when, and what changed. Written on Manage Access, the profile edit form and new-user creation. Nothing here can be edited or deleted.</p>
      </div>
    </div>
    <div class="hist-filters">
      <input type="text" class="hist-input" placeholder="Search a person or who made the change" [(ngModel)]="histSearch" (ngModelChange)="onHistFilterChange()" />
      <label class="hist-check"><input type="checkbox" [(ngModel)]="histFinanceOnly" (ngModelChange)="onHistFilterChange()" /> Finance changes only</label>
      <label class="hist-date">From <input type="date" [(ngModel)]="histFrom" (ngModelChange)="onHistFilterChange()" /></label>
      <label class="hist-date">To <input type="date" [(ngModel)]="histTo" (ngModelChange)="onHistFilterChange()" /></label>
      <span class="hist-count">{{ histTotal }} change{{ histTotal === 1 ? '' : 's' }}</span>
    </div>
    @if (histLoading && !histRows.length) {
      <div class="flows-empty">Loading…</div>
    } @else if (!histRows.length) {
      <div class="flows-empty">No access changes match.</div>
    } @else {
    <div class="hist-table-wrap">
      <table class="hist-table">
        <thead><tr><th>When</th><th>Changed by</th><th>Whose access</th><th>What changed</th><th>Where</th></tr></thead>
        <tbody>
          @for (r of histRows; track r._id) {
          <tr [class.fin]="histTouchesFinance(r)">
            <td class="hist-when">{{ histWhen(r.createdAt) }}</td>
            <td><span class="hist-name">{{ r.editorUserName }}</span><span class="hist-dept">{{ r.editorDepartment }}</span></td>
            <td><span class="hist-name">{{ r.targetUserName }}</span><span class="hist-dept">{{ r.targetDepartment }}</span></td>
            <td><div class="hist-chips">@for (c of histChanges(r); track c.text) { <span class="hist-chip" [ngClass]="c.kind">{{ c.text }}</span> }</div></td>
            <td class="hist-src">{{ histSource(r) }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    @if (histHasMore) { <div><button type="button" class="flows-btn" [disabled]="histLoading" (click)="loadMoreHistory()">{{ histLoading ? 'Loading…' : 'Show more' }}</button></div> }
    }
  </div>
  }

  <!-- ── Approval flows (Admin) ─────────────────────────────────────────── -->
  @if (viewMode === 'flows' && isAdmin) {
  <div class="flows-wrap">
    <div class="flows-head">
      <div>
        <h3>Approval flows</h3>
        <p>Vendor payment requests follow one of these. The requester picks from the flows open to their department; the default is pre-selected. Accounts always pay at the end.</p>
      </div>
      @if (!flowEdit) { <button type="button" class="flows-btn primary" (click)="editFlow()">+ New flow</button> }
    </div>

    <!-- How Link applies these flows (the server's routeVendorChain; founder, 2–3 Nov 2026) -->
    <div class="flow-rules">
      <div class="flow-rules-title">How Link applies them</div>
      <ul>
        <li><b>A payment for a project</b> always names the project and goes to its BD first — the BD's business head may approve for them; when the BD raises it, their business head approves. A "Business head" or "Project creator" step in the flow becomes this step. Put "Project BD (or their business head)" later in a flow to move it there. The flow's other steps follow, Small / urgent included.</li>
        <li><b>Internal / CAPEX</b> (no project) follows the Internal capex route below, whatever flow the requester picked. A step the requester's own department would take is skipped (HR's own request starts at the HR head; the HR head's own goes to an Admin). Admins' and Accounts' own requests keep their flow, without a business head.</li>
        <li><b>An Admin is added</b> when a payment is above the ₹10,000 small-vendor cap, and — in person — when it is over what its project's budget has left (with the requester's reason), for Small / urgent above ₹10,000, Accounts' own requests and HR above ₹10,000. Every ₹10,000 line counts the amount before GST — ₹10,000 + GST is within it — except the small-vendor cap, which counts what is paid in the month, GST included.</li>
        <li><b>A purchase request's payment</b> keeps its flow (BD purchase unless chosen otherwise): the business head's pick is their approval.</li>
      </ul>
    </div>

    @if (flowEdit) {
    <div class="flow-editor">
      @if (isInternalFlow(flowEdit)) { <div class="flow-internal-note">The Internal capex route: every internal / CAPEX payment outside Admins and Accounts follows it, whatever flow was picked. No business-head or project step belongs here.</div> }
      <div class="flow-field"><label>Name</label><input type="text" [(ngModel)]="flowEdit.name" placeholder="e.g. Event purchase" /></div>
      <div class="flow-field"><label>Steps (in order)</label>
        <div class="flow-steps">
          @for (st of flowEdit.steps; track $index; let i = $index) {
          <span class="flow-step">{{ i + 1 }}. {{ flowRoleLabel(st) }}
            <button type="button" (click)="moveFlowStep(i, -1)" [disabled]="i === 0" title="Move up">↑</button>
            <button type="button" (click)="moveFlowStep(i, 1)" [disabled]="i === flowEdit.steps.length - 1" title="Move down">↓</button>
            <button type="button" (click)="removeFlowStep(i)" title="Remove">✕</button></span>
          }
          <span class="flow-step fixed">{{ flowEdit.steps.length + 1 }}. Accounts (pay) — always last</span>
        </div>
        <div class="flow-add">
          <select [(ngModel)]="flowAddRole"><option value="">Add a step…</option>@for (r of flowRoleChoices; track r.role) { <option [value]="r.role">{{ r.label }}</option> }</select>
          <button type="button" class="flows-btn" [disabled]="!flowAddRole" (click)="addFlowStep()">Add step</button>
        </div>
        @if (isInternalFlow(flowEdit)) { <small>At least one step. HR means anyone in HR.</small> }
        @else { <small>No steps = straight to Accounts (a project payment still goes to its BD first). A payment over the ₹10,000 small-vendor cap (a month, GST included) always gets an Admin step added automatically.</small> }
      </div>
      @if (isInternalFlow(flowEdit)) {
      <div class="flow-field"><label>An Admin approves too above <small>(₹, before GST; 0 = every internal payment)</small></label>
        <input type="number" min="0" step="500" [(ngModel)]="flowEdit.adminAbove" class="flow-amount" />
      </div>
      } @else {
      <div class="flow-field"><label>Who can use it <small>(none selected = everyone)</small></label>
        <div class="flow-tags">@for (d of FLOW_DEPTS; track d) { <button type="button" class="flow-tag" [class.on]="flowEdit.requesterDepartments.includes(d)" (click)="toggleFlowDept('requesterDepartments', d)">{{ d }}</button> }</div>
      </div>
      <div class="flow-field"><label>Default for <small>(each department has one default; choosing it here moves it from any other flow)</small></label>
        <div class="flow-tags">@for (d of flowDefaultChoices; track d) { <button type="button" class="flow-tag" [class.on]="flowEdit.defaultFor.includes(d)" (click)="toggleFlowDept('defaultFor', d)">{{ d }}</button> }</div>
      </div>
      <label class="flow-active"><input type="checkbox" [(ngModel)]="flowEdit.active" /> In use</label>
      }
      @if (flowError) { <div class="flow-error">{{ flowError }}</div> }
      <div class="flow-actions">
        <button type="button" class="flows-btn" (click)="flowEdit = null">Cancel</button>
        <button type="button" class="flows-btn primary" (click)="saveFlow()">Save flow</button>
      </div>
    </div>
    }

    @if (flowsLoading) { <div class="flows-empty">Loading…</div> }
    @if (internalFlow; as f) {
    <div class="flow-card internal">
      <div class="flow-card-main">
        <div class="flow-name">{{ f.name }} <span class="flow-kind">internal / CAPEX route</span>@if (f.notSaved) { <span class="flow-off">defaults, not saved yet</span> }</div>
        <div class="flow-chain">{{ flowChain(f) }}</div>
        <div class="flow-meta">Every internal payment outside Admins and Accounts, whatever flow was picked · an Admin approves too above ₹{{ inrAmount(f.adminAbove ?? INTERNAL_ADMIN_ABOVE_DEFAULT) }} + GST</div>
      </div>
      <div class="flow-card-actions">
        <button type="button" class="flows-btn" (click)="editFlow(f)">Edit</button>
      </div>
    </div>
    }
    @for (f of pickableFlows; track f.id) {
    <div class="flow-card" [class.off]="f.active === false">
      <div class="flow-card-main">
        <div class="flow-name">{{ f.name }} @if (f.active === false) { <span class="flow-off">not in use</span> }</div>
        <div class="flow-chain">{{ flowChain(f) }}</div>
        <div class="flow-meta">Used by: {{ f.requesterDepartments?.length ? f.requesterDepartments.join(', ') : 'everyone' }}@if (f.defaultFor?.length) { · Default for: {{ f.defaultFor.join(', ') }} }</div>
      </div>
      <div class="flow-card-actions">
        <button type="button" class="flows-btn" (click)="editFlow(f)">Edit</button>
        <button type="button" class="flows-btn danger" (click)="removeFlow(f)">Remove</button>
      </div>
    </div>
    } @empty {
    @if (!flowsLoading) { <div class="flows-empty">No flows yet.</div> }
    }
  </div>
  }

  @if (viewMode === 'profiles') {
  <div class="main-content-wrapper">
    <!-- Form Card -->
    @if (!isMobileView || activeTab === 'create') {
    <div class="form-card">
      <div class="section-header">
        <div class="section-header-title">
          <h1>{{ isEditMode ? 'Edit User Profile' : 'Create User Profile' }}</h1>
          <p>{{ isEditMode ? 'Update account details and permissions' : 'Set up a new user account and assign modules'
            }}</p>
        </div>
        <div class="section-header-actions">
          <button type="button" class="btn-export-users" (click)="openExportModal()" title="Export Users to Excel">
            <i class="fas fa-file-excel mr-2"></i>
            <span>Export</span>
          </button>
        </div>
      </div>

      <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
        <div class="form-layout">
          <!-- Photo Upload Section -->
          <div class="upload-sidebar">
            <!-- <label class="form-group label mb-3">Profile Photo</label> -->
            <div class="photo-upload-wrapper">
              @if(!showCropper) {
              <label for="file" class="upload-box">
                @if(imagePreview) {
                <img [src]="imagePreview" alt="Preview" class="image-preview" />
                <div class="edit-overlay">
                  <i class="fas fa-camera"></i>
                </div>
                } @else {
                <i class="fas fa-cloud-upload-alt"></i>
                <span>Upload photo</span>
                }
                <input id="file" name="file" type="file" accept="image/*" (change)="fileChangeEvent($event)" hidden />
              </label>
              } @else {
              <div class="cropper-container">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                  [aspectRatio]="1 / 1" [resizeToWidth]="500" format="jpeg" (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
                  style="height: 250px"></image-cropper>

                <div class="cropper-actions">
                  <button type="button" class="btn-secondary py-2 px-3" (click)="cancelCrop()">Cancel</button>
                  <button type="button" class="btn-primary py-2 px-3" (click)="saveCrop()">Apply</button>
                </div>
              </div>
              }
            </div>
          </div>

          <!-- Fields Section -->
          <div class="fields-container">
            <div class="fields-grid">
              <!-- First Name -->
              <div class="form-group">
                <label for="firstName">First Name <span class="text-danger">*</span></label>
                <input id="firstName" formControlName="firstName" type="text" placeholder="e.g. John"
                  [ngClass]="{'is-invalid': signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched}" />
                @if(signupForm.get('firstName')?.invalid && signupForm.get('firstName')?.touched) {
                <div class="text-danger">First name is required.</div>
                }
              </div>

              <!-- Last Name -->
              <div class="form-group">
                <label for="lastName">Last Name</label>
                <input id="lastName" formControlName="lastName" type="text" placeholder="e.g. Doe" />
              </div>

              <!-- Username -->
              <div class="form-group">
                <label for="userName">Username <span class="text-danger">*</span></label>
                <input id="userName" formControlName="userName" autocomplete="off" type="text" placeholder="johndoe123"
                  [ngClass]="{'is-invalid': signupForm.get('userName')?.invalid && signupForm.get('userName')?.touched}" />
                @if(signupForm.get('userName')?.invalid && signupForm.get('userName')?.touched) {
                <div class="text-danger">Username is required.</div>
                }
              </div>

              <!-- Password -->
              <div class="form-group position-relative">
                <label for="password">Password <span class="text-danger">*</span></label>
                <div class="position-relative">
                  <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password"
                    autocomplete="new-password" (input)="onPasswordInput($event)" placeholder="••••••••"
                    [ngClass]="{'is-invalid': signupForm.get('password')?.invalid && signupForm.get('password')?.touched}"
                    style="width: 100%;" />
                  @if(showToggleIcon) {
                  <button type="button" class="btn border-0 py-0 px-2 position-absolute"
                    (click)="showPassword = !showPassword"
                    style="right: 12px; top: 50%; transform: translateY(-50%); color: var(--text-muted);">
                    <i class="{{ showPassword ? 'fas fa-eye' : 'fas fa-eye-slash' }}"></i>
                  </button>
                  }
                </div>
                @if(signupForm.get('password')?.invalid && signupForm.get('password')?.touched) {
                <div class="text-danger">Password is required.</div>
                }
              </div>

              <!-- Employee ID -->
              <div class="form-group">
                <label for="employeeId">Employee ID</label>
                <input id="employeeId" formControlName="employeeId" type="text" placeholder="e.g. EMP-0113" />
              </div>

              <!-- Email -->
              <div class="form-group">
                <label for="email">Email Address <span class="text-danger">*</span></label>
                <input id="email" formControlName="email" type="email" placeholder="john.doe@iiclab.com"
                  [ngClass]="{'is-invalid': signupForm.get('email')?.invalid && signupForm.get('email')?.touched}" />
                @if(signupForm.get('email')?.invalid && signupForm.get('email')?.touched) {
                <div class="text-danger">Valid email is required.</div>
                }
              </div>

              <!-- Department -->
              <div class="form-group">
                <label>Department <span class="text-danger">*</span></label>
                <div class="dropdown custom-select-wrapper">
                  <div class="custom-select-btn" id="departmentDropdown" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
                    [ngClass]="{'is-invalid': signupForm.get('department')?.invalid && signupForm.get('department')?.touched}">
                    {{ signupForm.get("department")?.value || "Select Department" }}
                    <i class="fas fa-chevron-down dropdown-chevron"></i>
                  </div>
                  <div class="dropdown-menu" aria-labelledby="departmentDropdown">
                    @for (dept of selectableDepartments; track dept) {
                    <div class="dropdown-item" (click)="selectDepartment(dept.departmentName || dept.name || dept)">
                      {{ dept.departmentName || dept.name || dept }}
                    </div>
                    } 
                 
                  </div>
                </div>
                @if(signupForm.get('department')?.invalid && signupForm.get('department')?.touched) {
                <div class="text-danger">Department is required.</div>
                }
              </div>

              <!-- Office Location -->
              <div class="form-group">
                <label>Office Location <span class="text-danger">*</span></label>
                <div class="dropdown custom-select-wrapper">
                  <div class="custom-select-btn" id="officeLocationDropdown" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
                    [ngClass]="{'is-invalid': signupForm.get('officeLocation')?.invalid && signupForm.get('officeLocation')?.touched}">
                    {{ signupForm.get("officeLocation")?.value || "Select Location" }}
                    <i class="fas fa-chevron-down dropdown-chevron"></i>
                  </div>
                  <div class="dropdown-menu" aria-labelledby="officeLocationDropdown">
                    <div class="dropdown-item" (click)="selectLocation('MUMBAI')">MUMBAI</div>
                    <div class="dropdown-item" (click)="selectLocation('LUCKNOW')">LUCKNOW</div>
                  </div>
                </div>
                @if(signupForm.get('officeLocation')?.invalid && signupForm.get('officeLocation')?.touched) {
                <div class="text-danger">Office Location is required.</div>
                }
              </div>

              <!-- Module Access -->
              <div class="form-group">
                <label>Module Access <span class="text-danger">*</span></label>
                <div class="dropdown custom-select-wrapper">
                  <div class="custom-select-btn" id="moduleAccessDropdown" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
                    [ngClass]="{'is-invalid': signupForm.get('modules')?.invalid && signupForm.get('modules')?.touched}">
                    {{ signupForm.get("modules")?.value?.length || 0 }} modules selected
                    <i class="fas fa-chevron-down dropdown-chevron"></i>
                  </div>
                  <div class="dropdown-menu p-3" aria-labelledby="moduleAccessDropdown"
                    style="min-width: 270px; max-height: 320px; overflow-y: auto;">
                    @for (module of visibleModuleOptions; track module.value) {
                    <div class="module-option-item mb-2" [class.finance-module-item]="module.value === 'FINANCE'"
                      (click)="$event.stopPropagation()">
                      <div class="form-check" [class.finance-form-check]="module.value === 'FINANCE'">
                        <input class="form-check-input" type="checkbox" [id]="'module-' + module.value"
                          [checked]="isModuleSelected(module.value)" [disabled]="isModuleDisabled(module.value)"
                          (change)="toggleModule(module.value)"
                          [title]="isModuleDisabled(module.value) ? financeLockReason : ''" />
                        <label class="form-check-label ml-2" [for]="'module-' + module.value"
                          [style.cursor]="isModuleDisabled(module.value) ? 'not-allowed' : 'pointer'"
                          [style.opacity]="isModuleDisabled(module.value) ? '0.6' : '1'"
                          style="font-size: 13px; font-weight: 500;">
                          {{ module.label }}
                          @if (isModuleDisabled(module.value)) {
                          <i class="fas fa-lock ml-1" style="font-size: 10px; color: var(--text-muted);"></i>
                          }
                        </label>
                      </div>

                      @if (module.value === 'FINANCE') {
                      <div class="finance-submodules-container ml-4 mt-1 p-2"
                        style="background: var(--soft-indigo); border-radius: 6px; border-left: 3px solid #6366f1;">
                        <div class="text-muted mb-1"
                          style="font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">
                          Sub-Modules
                        </div>
                        @for (sub of financeSubModulesList; track sub.value) {
                        <div class="form-check mb-1" [class.submodule-disabled]="isFinanceSubModuleDisabled(sub.value)">
                          <input class="form-check-input" type="checkbox" [id]="'submodule-' + sub.value"
                            [checked]="isFinanceSubModuleSelected(sub.value)"
                            [disabled]="isFinanceSubModuleDisabled(sub.value)"
                            (change)="toggleFinanceSubModule(sub.value)" />
                          <label class="form-check-label ml-2" [for]="'submodule-' + sub.value"
                            [style.cursor]="isFinanceSubModuleDisabled(sub.value) ? 'not-allowed' : 'pointer'"
                            [style.opacity]="isFinanceSubModuleDisabled(sub.value) ? '0.6' : '1'"
                            style="font-size: 12px; font-weight: 500;">
                            {{ sub.label }}
                            <span class="text-muted d-block" style="font-size: 10.5px; font-weight: 400;">({{
                              sub.description }})</span>
                          </label>
                        </div>
                        }
                      </div>
                      }
                      @if (module.value === 'VAULT') {
                      <div class="finance-submodules-container ml-4 mt-1 p-2"
                        style="background: var(--soft-indigo); border-radius: 6px; border-left: 3px solid #6366f1;">
                        <div class="text-muted mb-1"
                          style="font-size: 10.5px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px;">
                          Knowledge base
                        </div>
                        @for (sub of vaultSubModulesList; track sub.value) {
                        <div class="form-check mb-1">
                          <input class="form-check-input" type="checkbox" [id]="'submodule-' + sub.value"
                            [checked]="isVaultSubModuleSelected(sub.value)" (change)="toggleVaultSubModule(sub.value)" />
                          <label class="form-check-label ml-2" [for]="'submodule-' + sub.value" style="font-size: 12px; font-weight: 500; cursor: pointer;">
                            {{ sub.label }}
                            <span class="text-muted d-block" style="font-size: 10.5px; font-weight: 400;">({{ sub.description }}; Admin, HR and department heads are curators without this tick)</span>
                          </label>
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
                @if(signupForm.get('modules')?.invalid && signupForm.get('modules')?.touched) {
                <div class="text-danger">Module access is required.</div>
                }
              </div>

              <!-- SSO Certification Group -->
              <div class="sso-certification-group">
                <label class="sso-section-label">SSO Authentication</label>
                <div class="sso-group-fields">
                  <!-- Gmail -->
                  <div class="form-group">
                    <label>Gmail</label>
                    <div class="dropdown custom-select-wrapper">
                      <div class="custom-select-btn" id="isEmailCreatedDropdown" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        {{ signupForm.get("isEmailCreated")?.value === true || signupForm.get("isEmailCreated")?.value
                        ===
                        'true' ? 'Yes' : (signupForm.get("isEmailCreated")?.value === false ||
                        signupForm.get("isEmailCreated")?.value === 'false' ? 'No' : 'Select Gmail') }}
                        <i class="fas fa-chevron-down dropdown-chevron"></i>
                      </div>
                      <div class="dropdown-menu" aria-labelledby="isEmailCreatedDropdown">
                        <div class="dropdown-item" (click)="selectIsEmailCreated(true)">Yes</div>
                        <div class="dropdown-item" (click)="selectIsEmailCreated(false)">No</div>
                      </div>
                    </div>
                  </div>

                  <!-- Laptop Admin Password -->
                  <div class="form-group">
                    <label>Laptop Admin Password</label>
                    <div class="dropdown custom-select-wrapper">
                      <div class="custom-select-btn" id="isLaptopAdminPasswordDropdown" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        {{ signupForm.get("isLaptopAdminPasswordSet")?.value === true ||
                        signupForm.get("isLaptopAdminPasswordSet")?.value ===
                        'true' ? 'Yes' : (signupForm.get("isLaptopAdminPasswordSet")?.value === false ||
                        signupForm.get("isLaptopAdminPasswordSet")?.value === 'false' ? 'No' : 'Select Laptop Admin
                        Password') }}
                        <i class="fas fa-chevron-down dropdown-chevron"></i>
                      </div>
                      <div class="dropdown-menu" aria-labelledby="isLaptopAdminPasswordDropdown">
                        <div class="dropdown-item" (click)="selectIsLaptopAdminPasswordSet(true)">Yes</div>
                        <div class="dropdown-item" (click)="selectIsLaptopAdminPasswordSet(false)">No</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Access Control -->
              <div class="form-group full-width-field"
                [class.dropdown-open]="showTagSuggestions && (filteredTagSuggestions.length > 0 || tagSearchInput.trim())">
                <label for="accessControl">Access Control</label>
                <div class="access-tags-container" (click)="focusTagInput()">
                  <!-- Top area: Selected tags/chips (scrollable) -->
                  @if (accessTagsList.length > 0) {
                  <div class="selected-tags-area">
                    @for (tag of accessTagsList; track tag; let i = $index) {
                    <span class="access-tag-badge">
                      <span class="tag-text">{{ tag }}</span>
                      <button type="button" class="btn-remove-tag" (click)="removeAccessTag(i, $event)"
                        title="Remove tag">
                        <i class="fas fa-times"></i>
                      </button>
                    </span>
                    }
                  </div>
                  }

                  <!-- Bottom area: Text input for typing/adding new tags -->
                  <div class="tag-input-row">
                    <input #tagInput id="accessControl" type="text" class="tag-inline-input"
                      [placeholder]="accessTagsList.length === 0 ? 'Type or select access tags...' : 'Add more access tags...'"
                      [(ngModel)]="tagSearchInput" [ngModelOptions]="{standalone: true}" (focus)="onTagInputFocus()"
                      (input)="onTagSearchChange($event)" (keydown)="onTagKeyDown($event)" />

                    @if (showTagSuggestions) {
                    <button type="button" class="btn-close-dropdown" (click)="closeTagSuggestions($event)"
                      title="Close suggestions">
                      <i class="fas fa-times"></i>
                    </button>
                    }
                  </div>

                  <!-- Autocomplete Suggestions Dropdown -->
                  @if (showTagSuggestions && (filteredTagSuggestions.length > 0 || tagSearchInput.trim())) {
                  <div class="tag-suggestions-dropdown" (mousedown)="$event.preventDefault()">
                    @if (filteredTagSuggestions.length > 0) {
                    <div class="suggestions-header">Suggested Tags</div>
                    @for (suggestion of filteredTagSuggestions; track suggestion) {
                    <div class="suggestion-item" (click)="selectTagSuggestion(suggestion)">
                      <i class="fas fa-tag mr-2"></i>
                      <span>{{ suggestion }}</span>
                    </div>
                    }
                    }
                    @if (tagSearchInput.trim() && !filteredTagSuggestions.includes(tagSearchInput.trim()) &&
                    !accessTagsList.includes(tagSearchInput.trim())) {
                    <div class="suggestion-item add-custom-tag" (click)="addAccessTag(tagSearchInput.trim())">
                      <i class="fas fa-plus mr-2"></i>
                      <span>Add "<strong>{{ tagSearchInput.trim() }}</strong>"</span>
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>

            <div class="form-actions">
              @if(isEditMode) {
              <button type="button" class="btn-secondary" (click)="resetForm()">Cancel</button>
              }
              <button type="submit" class="btn-primary">
                {{ isEditMode ? "Update Profile" : "Create Profile" }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    }

    <!-- Sidebar Card -->
    @if (!isMobileView || activeTab === 'view') {
    <div class="sidebar-card view-user-mode">
      <div class="sidebar-header">
        <div class="sidebar-title-row">
          <h2>Total Users</h2>
          <div class="header-right-actions">
            <div class="dropdown dept-filter-dropdown">
              <button class="btn btn-dept-filter dropdown-toggle" [class.is-filtered]="!!selectedDepartmentFilter"
                type="button" id="deptFilterMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-filter filter-icon"></i>
                <span class="selected-dept-label">{{ selectedDepartmentFilter || 'All Departments' }}</span>
                <i class="fas fa-chevron-down chevron-icon"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="deptFilterMenu">
                <div class="dropdown-item" [class.active]="!selectedDepartmentFilter" (click)="filterByDepartment('')">
                  <i class="fas fa-layer-group mr-2"></i> All Departments
                </div>
                <div class="dropdown-divider"></div>
                @for(dept of departments; track dept) {
                <div class="dropdown-item" [class.active]="selectedDepartmentFilter === getDeptName(dept)"
                  (click)="filterByDepartment(getDeptName(dept))">
                  <i class="fas fa-building mr-2"></i> {{ getDeptName(dept) }}
                </div>
                }
              </div>
            </div>
            <span class="user-count-badge">{{ totalUser }}</span>
          </div>
        </div>
      </div>

      @if (isAdmin || isPeopleAdmin) {
        <label class="show-suspended"><input type="checkbox" [(ngModel)]="showSuspended" (ngModelChange)="showUserList()" /> Show suspended people</label>
      }
      <div class="search-wrapper">
        <i class="fas fa-search"></i>
        <input type="text" placeholder="Search users by name..." [(ngModel)]="searchQuery"
          (ngModelChange)="onSearchChange($event)" />
        @if (searchQuery) {
        <button class="btn border-0 py-0 px-2 position-absolute" (click)="clearSearch()"
          style="right: 12px; top: 50%; transform: translateY(-50%); color: var(--text-muted);">
          <i class="fas fa-times"></i>
        </button>
        }
      </div>

      @if (openUserMenu && menuUser) {
        <div class="user-menu" [style.top.px]="menuPos.top" [style.left.px]="menuPos.left" (click)="$event.stopPropagation()">
          <div class="user-menu-head">{{ menuUser.firstName }} {{ menuUser.lastName }}</div>
          @if (menuUser.revoked) {
            <button type="button" class="ok" (click)="onUnsuspendUser(menuUser); closeUserMenu()"><span class="material-symbols-outlined">lock_open</span>Unsuspend</button>
          } @else {
            <button type="button" class="warn" (click)="onSuspendUser(menuUser); closeUserMenu()"><span class="material-symbols-outlined">pause_circle</span>Suspend…</button>
          }
          @if ((isAdmin || isPeopleAdmin) && (menuUser.department || '').toUpperCase() !== 'ADMIN') {
            <button type="button" (click)="onAuditAccess(menuUser); closeUserMenu()"><span class="material-symbols-outlined">visibility</span>View as (audit)…</button>
          }
          @if (isAdmin) {
            <button type="button" (click)="onResetPassword(menuUser); closeUserMenu()"><span class="material-symbols-outlined">key</span>Reset password…</button>
            <button type="button" class="danger" (click)="onDeleteUser(menuUser); closeUserMenu()"><span class="material-symbols-outlined">delete</span>Delete…</button>
          }
        </div>
      }
      <div class="user-list-container" (scroll)="closeUserMenu()">
        @for(user of users; track user){
        <div class="user-item">
          <img [src]="user.profileImg || 'assets/images/default-avatar.png'" class="user-avatar" alt="Avatar"
            onerror="this.src='https://ui-avatars.com/api/?name='+user.firstName+'+'+user.lastName+'&background=random'" />
          <div class="user-info flex-column d-flex">
            <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
            <span class="user-dept">{{ user.department }}</span>
            @if (user.revoked) {
              <span class="user-suspended" [title]="(user.suspendReason || '') + (user.suspendedBy?.userName ? ' · by ' + user.suspendedBy.userName : '')">Suspended</span>
            }
            @if (user.modules && user.modules.length > 0) {
            <span class="user-modules" [title]="getFormattedModules(user)">{{ getFormattedModules(user)
              }}</span>
            }
          </div>
          <div class="user-actions">
            <button class="action-btn edit" (click)="onEditUser(user)" title="Edit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                <path fill="#93a9d3"
                  d="M5 19h1.425L16.2 9.225L14.775 7.8L5 17.575zm-2 2v-4.25L16.2 3.575q.3-.275.663-.425t.762-.15t.775.15t.65.45L20.425 5q.3.275.438.65T21 6.4q0 .4-.137.763t-.438.662L7.25 21zM19 6.4L17.6 5zm-3.525 2.125l-.7-.725L16.2 9.225z"
                  stroke-width="0.5" stroke="#93a9d3" />
              </svg>
            </button>
            @if (isAdmin || isPeopleAdmin) {
              <button class="action-btn more" (click)="toggleUserMenu(user._id, $event)" title="More actions" [attr.aria-expanded]="openUserMenu === user._id">
                <span class="material-symbols-outlined">more_horiz</span>
              </button>
            }
          </div>
        </div>
        }

        @if(users.length === 0) {
        <div class="text-center mt-5 py-4">
          <img width="120" src="https://img.freepik.com/free-vector/flat-design-no-data-illustration_23-2150527130.jpg"
            alt="No data" style="opacity: 0.6;" />
          <p class="mt-3" style="color: var(--text-muted); font-size: 14px;">No users found</p>
        </div>
        }
      </div>
    </div>
    }
  </div>
  }

  <!-- Manage Access: every user, grouped by department, access as tick boxes -->
  @if (viewMode === 'access') {
  <div class="access-panel">
    <div class="access-toolbar">
      <div class="access-title">
        <h1>Manage Access</h1>
        <p>Tick or untick what each person can open. Nothing is saved until you press <strong>Save changes</strong>.</p>
      </div>
      <div class="access-controls">
        <div class="search-wrapper access-search">
          <i class="fas fa-search"></i>
          <input type="text" placeholder="Search name or username" [(ngModel)]="accessSearch"
            (ngModelChange)="rebuildAccessGroups()" />
        </div>
        <select class="access-select" [(ngModel)]="accessDeptFilter" (ngModelChange)="rebuildAccessGroups()">
          <option value="">All departments</option>
          @for (d of accessDepartments; track d) {
          <option [value]="d">{{ d }}</option>
          }
        </select>
        <label class="access-toggle">
          <input type="checkbox" [(ngModel)]="accessOnlyChanged" (ngModelChange)="rebuildAccessGroups()" />
          Only changed
        </label>
        <button type="button" class="btn-secondary" (click)="discardAccessChanges()"
          [disabled]="!changedCount || accessSaving">Discard</button>
        <button type="button" class="btn-primary" (click)="saveAccessChanges()"
          [disabled]="!changedCount || accessSaving">
          {{ accessSaving ? 'Saving…' : (changedCount ? 'Save changes (' + changedCount + ')' : 'Save changes') }}
        </button>
      </div>
    </div>

    @if (!isAdmin) {
    <div class="access-note">
      <i class="fas fa-lock mr-2"></i>
      Finance access (Projects and Vendors) and Admin users can only be changed by an Admin. Locked boxes are greyed out.
    </div>
    }

    @if (accessLoading) {
    <div class="access-empty">Loading users…</div>
    }

    @for (g of accessGroups; track g.dept) {
    <div class="access-dept">
      <button type="button" class="access-dept-header" (click)="toggleDept(g.dept)">
        <i class="fas" [ngClass]="collapsedDepts.has(g.dept) ? 'fa-chevron-right' : 'fa-chevron-down'"></i>
        <span class="access-dept-name">{{ g.dept }}</span>
        <span class="user-count-badge">{{ g.users.length }}</span>
        <span class="access-dept-meta">{{ g.financeCount }} with Finance</span>
        @if (g.changedCount) {
        <span class="access-changed-pill">{{ g.changedCount }} changed</span>
        }
      </button>

      @if (!collapsedDepts.has(g.dept)) {
      <div class="access-table-wrap">
        <table class="access-table">
          <thead>
            <tr>
              <th class="col-user">User</th>
              @for (m of accessModuleColumns; track m.value) {
              <th [title]="m.value">{{ m.short }}</th>
              }
              <th class="col-fin" title="Finance → Dashboard, Projects, Invoices">Fin · Projects</th>
              <th class="col-fin" title="Finance → Vendors">Fin · Vendors</th>
              <th class="col-fin" title="Finance → Budgets (the quarter sheets): HR head, HR, IT and Accounts; Admins too only when ticked">Fin · Budgets</th>
            </tr>
          </thead>
          <tbody>
            @for (u of g.users; track u._id) {
            <tr [class.row-changed]="isAccessChanged(u)" [class.row-locked]="!canEditUser(u)"
              [class.row-error]="accessErrors.has(u._id)">
              <td class="col-user">
                <div class="access-user">
                  <img [src]="u.profileImg || 'assets/images/default-avatar.png'" class="user-avatar" alt=""
                    onerror="this.src='https://ui-avatars.com/api/?name=U&background=random'" />
                  <div class="access-user-text">
                    <span class="user-name">
                      {{ u.firstName }} {{ u.lastName }}
                      @if (u.isHead) {
                      <span class="access-head-pill">Head</span>
                      }
                    </span>
                    <span class="user-dept">{{ u.userName }}</span>
                    @if (accessErrors.has(u._id)) {
                    <span class="access-error">{{ accessErrors.get(u._id) }}</span>
                    }
                  </div>
                </div>
              </td>
              @for (m of accessModuleColumns; track m.value) {
              <td class="col-check" [class.cell-locked]="!canEditModule(u, m.value)">
                <input type="checkbox" [checked]="hasAccessModule(u, m.value)" [disabled]="!canEditModule(u, m.value)"
                  (change)="toggleAccessModule(u, m.value)" [title]="lockReason(u, m.value)" />
              </td>
              }
              <td class="col-check col-fin" [class.cell-locked]="!canEditFinanceSub(u, 'PROJECTS')">
                <input type="checkbox" [checked]="hasFinanceSub(u, 'PROJECTS')"
                  [disabled]="!canEditFinanceSub(u, 'PROJECTS')" (change)="toggleAccessFinanceSub(u, 'PROJECTS')"
                  [title]="lockReason(u, 'FINANCE')" />
              </td>
              <td class="col-check col-fin" [class.cell-locked]="!canEditFinanceSub(u, 'VENDORS')">
                <input type="checkbox" [checked]="hasFinanceSub(u, 'VENDORS')"
                  [disabled]="!canEditFinanceSub(u, 'VENDORS')" (change)="toggleAccessFinanceSub(u, 'VENDORS')"
                  [title]="lockReason(u, 'FINANCE')" />
              </td>
              <td class="col-check col-fin" [class.cell-locked]="!canEditFinanceSub(u, 'BUDGETS')">
                <input type="checkbox" [checked]="hasFinanceSub(u, 'BUDGETS')"
                  [disabled]="!canEditFinanceSub(u, 'BUDGETS')" (change)="toggleAccessFinanceSub(u, 'BUDGETS')"
                  [title]="lockReason(u, 'FINANCE')" />
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      }
    </div>
    }

    @if (!accessLoading && !accessGroups.length) {
    <div class="access-empty">No users match.</div>
    }
  </div>
  }

  <!-- Export Users Modal -->
  @if (showExportModal) {
  <div class="export-modal-overlay" (click)="closeExportModal()">
    <div class="export-modal-container" (click)="$event.stopPropagation()">
      <div class="export-modal-header">
        <div class="export-header-title">
          <div class="export-icon-badge">
            <i class="fas fa-file-excel"></i>
          </div>
          <div>
            <h3>Export Users to Excel</h3>
            <p class="export-header-sub">Download user profiles with department filter</p>
          </div>
        </div>
        <button type="button" class="export-modal-close" (click)="closeExportModal()" [disabled]="isExporting"
          title="Close">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="export-modal-body">
        <div class="export-field-group">
          <label class="export-label">
            <i class="fas fa-building mr-1"></i> Filter by Department
          </label>
          <div class="custom-export-dept-wrapper" [class.open]="isExportDeptDropdownOpen"
            (click)="$event.stopPropagation()">
            <button type="button" class="custom-export-dept-trigger" (click)="toggleExportDeptDropdown($event)"
              [disabled]="isExporting">
              <span class="custom-dept-label">
                <i class="fas" [ngClass]="selectedExportDepartment ? 'fa-building' : 'fa-layer-group'"></i>
                {{ selectedExportDepartment || 'All Departments (All Users)' }}
              </span>
              <i class="fas fa-chevron-down custom-dept-chevron" [class.rotated]="isExportDeptDropdownOpen"></i>
            </button>

            @if (isExportDeptDropdownOpen) {
            <div class="custom-export-dept-menu" (click)="$event.stopPropagation()">
              <div class="custom-export-dept-option" [class.active]="!selectedExportDepartment"
                (click)="selectExportDept('', $event)">
                <div class="dept-opt-left">
                  <i class="fas fa-layer-group dept-opt-icon"></i>
                  <span>All Departments (All Users)</span>
                </div>
                @if (!selectedExportDepartment) {
                <i class="fas fa-check check-icon"></i>
                }
              </div>

              <div class="custom-export-dept-divider"></div>

              @for (dept of departments; track dept) {
              <div class="custom-export-dept-option" [class.active]="selectedExportDepartment === getDeptName(dept)"
                (click)="selectExportDept(getDeptName(dept), $event)">
                <div class="dept-opt-left">
                  <i class="fas fa-building dept-opt-icon"></i>
                  <span>{{ getDeptName(dept) }}</span>
                </div>
                @if (selectedExportDepartment === getDeptName(dept)) {
                <i class="fas fa-check check-icon"></i>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>

        <div class="export-info-box">
          <div class="export-info-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="export-info-text">
            <div class="export-info-heading">Excel (.xlsx) report contains:</div>
            <div class="export-info-desc">
              Employee ID, Full Name, Username, Email, Department, Location, Assigned Modules, Access Tags, SSO &
              Account Flags.
            </div>
          </div>
        </div>
      </div>

      <div class="export-modal-footer">
        <button type="button" class="btn-export-cancel" (click)="closeExportModal()" [disabled]="isExporting">
          Cancel
        </button>
        <button type="button" class="btn-export-confirm" (click)="exportUsersToExcel()" [disabled]="isExporting">
          @if (isExporting) {
          <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"
            style="width: 14px; height: 14px; border-width: 2px;"></span>
          <span>Exporting…</span>
          } @else {
          <i class="fas fa-file-download mr-2"></i>
          <span>Download Excel (.xlsx)</span>
          }
        </button>
      </div>
    </div>
  </div>
  }
</div>